import { render, staticRenderFns } from "./FinanceDash.vue?vue&type=template&id=32b8c279&scoped=true&"
import script from "./FinanceDash.vue?vue&type=script&lang=js&"
export * from "./FinanceDash.vue?vue&type=script&lang=js&"
import style0 from "./FinanceDash.vue?vue&type=style&index=0&id=32b8c279&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32b8c279",
  null
  
)

export default component.exports